/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getNftConfigFromProps } from '../helpers';
import type { MoonPayNftProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPayNftCheckoutWidget(props: MoonPayNftProps) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getNftConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: props.signature || '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
